<template>
  <section class="table by4">
    <ul>
      <li><label>STAT</label><label>NBR</label><label>PRIX</label><label>P.C</label></li>
    </ul>
    <ul>
      <li>
        <span><i style="color:var(--grey)">⬤</i> Disponible</span>
        <span>{{ quantity[0] }}</span>
        <span>{{ price[0] | euros }}</span>
        <span>{{ percentPrice[0] }} %</span>
      </li>
      <li>
        <span><i style="color:var(--yellow)">⬤</i> Optionné</span>
        <span>{{ quantity[1] }}</span>
        <span>{{ price[1] | euros }}</span>
        <span>{{ percentPrice[1] }} %</span>
      </li>
      <li>
        <span><i style="color:var(--reserved)">⬤</i> Réservé</span>
        <span>{{ quantity[2] }}</span>
        <span>{{ price[2] | euros }}</span>
        <span>{{ percentPrice[2] }} %</span>
      </li>
      <li>
        <span><i style="color:var(--financed)">⬤</i> Financé</span>
        <span>{{ quantity[3] }}</span>
        <span>{{ price[3] | euros }}</span>
        <span>{{ percentPrice[3] }} %</span>
      </li>
      <li>
        <span><i style="color:var(--acted)">⬤</i> Acté</span>
        <span>{{ quantity[4] }}</span>
        <span>{{ price[4] | euros }}</span>
        <span>{{ percentPrice[4] }} %</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'StatisticsProgramStatus',
  props: {
    numero: Number,
    customlots: Array
  },
  data () {
    return {
    }
  },
  computed: {
    lots: function () {
      if (this.numero === -1) return this.customlots
      return this.$store.getters.get_lots_by_program_num(this.numero)
    },
    total: function () {
      var total = 0
      this.lots.forEach(l => {
        total = total + l.spec.price
      })
      return total
    },
    quantity: function () {
      var quantity = []
      for (let i = 0; i < 5; i++) {
        quantity.push(this.lots.filter(l => Number(l.status) === i).length)
      }
      return quantity
    },
    lotsbystatus: function () {
      var lotsbystatus = []
      for (let i = 0; i < 5; i++) {
        lotsbystatus.push(this.lots.filter(l => Number(l.status) === i))
      }
      return lotsbystatus
    },
    price: function () {
      var price = []
      this.lotsbystatus.forEach(q => {
        if (q.length > 0) {
          var calc = 0
          q.forEach(l => {
            calc = calc + l.spec.price
          })
          price.push(calc)
        } else price.push(0)
      })
      return price
    },
    percent: function () {
      var percent = []
      this.quantity.forEach(q => {
        percent.push(Number(((q / this.lots.length) * 100).toFixed(2)))
      })
      if (percent.length < 1) return ''
      return percent
    },
    percentPrice: function () {
      var percentPrice = []
      this.price.forEach(p => {
        percentPrice.push(Number(((p / this.total) * 100).toFixed(2)))
      })
      return percentPrice
    }
  },
  methods: {
    dasharray: function (val) {
      var second = 100 - this.percent[val]
      return '' + this.percent[val] + ' ' + second
    },
    dashoffset: function (val) {
      if (val === 1) return 125 - (this.percent[0])
      else if (val === 2) return 125 - (this.percent[0] + this.percent[1])
      else if (val === 3) return 125 - (this.percent[0] + this.percent[1] + this.percent[2])
      else if (val === 4) return 125 - (this.percent[0] + this.percent[1] + this.percent[2] + this.percent[3])
    }
  }
}
</script>
